if (window.innerWidth > 767) {
 gsap.registerPlugin(ScrollTrigger);

const matchMedia = gsap.matchMedia();

const BOX_SELECTORS = [
  ".Bottom_right_position_new",
  ".Top_left_position_new",
  ".Top_right_position_new",
  ".Top_middle_position_new",
  ".Bottom_left_position_new",
];

function removeStyle(selector) {
  document.querySelectorAll(selector).forEach((el) => {
    el.removeAttribute("style");
  });
}

function clearBottomAnimation() {
  gsap.killTweensOf(BOX_SELECTORS);
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  matchMedia.revert();
}

function imageListAnimationDesktop() {
  BOX_SELECTORS.forEach(removeStyle);

  const section = document.querySelector(".Page_content_overlap_media_inner");
  const triggerEl = document.querySelector(".Page_content_overlap_media_main");

  if (!section || !triggerEl) return;

  let start = "top top";
  let end = "+=500";

  gsap.set(section, {
    overflow: "hidden",
    position: "relative",
    minHeight: "100svh",
  });

  ScrollTrigger.create({
    trigger: section,
    start: "top top",
    end: "+=500",
    pin: true,
    pinSpacing: true,
    scrub: true,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    markers: false,
  });

  function createAnimation(settings) {
    const { selector, trigger, duration, toStyles, start, end } = settings;

    gsap.to(selector, {
      duration,
      ...toStyles,
      ease: "none",
      scrollTrigger: {
        trigger,
        start,
        end,
        scrub: true,
        invalidateOnRefresh: true,
        markers: false,
      },
    });
  }

  function animateBoxes(viewportSettings) {
    viewportSettings.forEach((setting) => {
      createAnimation({
        selector: setting.selector,
        trigger: setting.trigger || triggerEl,
        duration: setting.duration || 0.5,
        toStyles: setting.toStyles,
        start: setting.start || start,
        end: setting.end || end,
      });
    });
  }

  matchMedia.add("(min-width: 1921px)", () => {
    gsap.set(".Top_left_position_new", {
      top: "33%",
      left: "42.666%",
      width: 184,
      rotate: -17.2,
    });
    gsap.set(".Top_middle_position_new", {
      top: "25%",
      left: "44%",
      width: 184,
      rotate: -9.15,
    });
    gsap.set(".Top_right_position_new", {
      top: "29.5%",
      left: "52%",
      width: 184,
      rotate: 158.33,
    });
    gsap.set(".Bottom_left_position_new", {
      bottom: "30%",
      left: "46.7%",
      width: 184,
      rotate: -2.37,
    });
    gsap.set(".Bottom_right_position_new", {
      bottom: "34%",
      left: "50.5%",
      width: 184,
      rotate: 11.38,
    });

    animateBoxes([
      {
        selector: ".Top_left_position_new",
        toStyles: { top: 32, left: -5.3439, width: 184, rotate: -17.2 },
      },
      {
        selector: ".Top_middle_position_new",
        toStyles: { top: "-21%", left: "44%", width: 184, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        toStyles: { top: "-4.5%", left: "80%", width: 184, rotate: -15.81 },
      },
      {
        selector: ".Bottom_left_position_new",
        toStyles: { bottom: "-15.4%", left: "21.6998%", width: 184, rotate: -2.37 },
      },
      {
        selector: ".Bottom_right_position_new",
        toStyles: { left: "70%", bottom: "-7.852%", width: 184, rotate: 11.38 },
      },
    ]);
  });

  matchMedia.add("(min-width: 1440px) and (max-width: 1920px)", () => {
    gsap.set(".Top_left_position_new", {
      top: "27%",
      left: "36.8%",
      width: 184,
      rotate: -17.2,
    });
    gsap.set(".Top_middle_position_new", {
      top: "15%",
      left: "40%",
      width: 184,
      rotate: -9.15,
    });
    gsap.set(".Top_right_position_new", {
      top: "23%",
      left: "50%",
      width: 184,
      rotate: 158.33,
    });
    gsap.set(".Bottom_left_position_new", {
      bottom: "17%",
      left: "41.7%",
      width: 184,
      rotate: -2.37,
    });
    gsap.set(".Bottom_right_position_new", {
      bottom: "22%",
      left: "50.2%",
      width: 184,
      rotate: 11.38,
    });

    animateBoxes([
      {
        selector: ".Top_left_position_new",
        toStyles: { top: 32, left: 0, width: 184, rotate: -17.2 },
      },
      {
        selector: ".Top_middle_position_new",
        toStyles: { top: "-35%", left: "40%", width: 184, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        toStyles: { top: "-6.5%", left: "80%", width: 184, rotate: -15.81 },
      },
      {
        selector: ".Bottom_left_position_new",
        toStyles: { bottom: "-25%", left: "21.6998%", width: 184, rotate: -2.37 },
      },
      {
        selector: ".Bottom_right_position_new",
        toStyles: { left: "70%", bottom: "-14%", width: 184, rotate: 11.38 },
      },
    ]);
  });

  matchMedia.add("(min-width: 991px) and (max-width: 1439px)", () => {
    gsap.set(".Top_left_position_new", {
      top: "25%",
      left: "36.666%",
      width: 150,
      rotate: -17.2,
    });
    gsap.set(".Top_middle_position_new", {
      top: "14%",
      left: "40%",
      width: 150,
      rotate: -9.15,
    });
    gsap.set(".Top_right_position_new", {
      top: "24.5%",
      left: "50%",
      width: 150,
      rotate: 158.33,
    });
    gsap.set(".Bottom_left_position_new", {
      bottom: "17.5%",
      left: "41.7%",
      width: 150,
      rotate: -2.37,
    });
    gsap.set(".Bottom_right_position_new", {
      bottom: "23%",
      left: "50.5%",
      width: 150,
      rotate: 11.38,
    });

    animateBoxes([
      {
        selector: ".Top_left_position_new",
        toStyles: { top: 32, left: 0, width: 150, rotate: -17.2 },
      },
      {
        selector: ".Top_middle_position_new",
        toStyles: { top: "-35%", left: "40%", width: 150, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        toStyles: { top: "-6.5%", left: "80%", width: 150, rotate: -15.81 },
      },
      {
        selector: ".Bottom_left_position_new",
        toStyles: { bottom: "-25%", left: "21.6998%", width: 150, rotate: -2.37 },
      },
      {
        selector: ".Bottom_right_position_new",
        toStyles: { left: "70%", bottom: "-14%", width: 150, rotate: 11.38 },
      },
    ]);
  });

  matchMedia.add("(min-width: 750px) and (max-width: 990px)", () => {
    gsap.set(".Top_left_position_new", {
      top: "25%",
      left: "30.666%",
      width: 150,
      rotate: -17.2,
    });
    gsap.set(".Top_middle_position_new", {
      top: "18%",
      left: "38%",
      width: 150,
      rotate: -9.15,
    });
    gsap.set(".Top_right_position_new", {
      top: "24.5%",
      left: "50%",
      width: 150,
      rotate: 158.33,
    });
    gsap.set(".Bottom_left_position_new", {
      bottom: "32.5%",
      left: "41.7%",
      width: 150,
      rotate: -2.37,
    });
    gsap.set(".Bottom_right_position_new", {
      bottom: "32%",
      left: "54.5%",
      width: 150,
      rotate: 11.38,
    });

    animateBoxes([
      {
        selector: ".Top_left_position_new",
        toStyles: { top: 32, left: 0, width: 120, rotate: -17.2 },
      },
      {
        selector: ".Top_middle_position_new",
        toStyles: { top: "-20%", left: "38%", width: 120, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        toStyles: { top: "-6.5%", left: "80%", width: 120, rotate: -15.81 },
      },
      {
        selector: ".Bottom_left_position_new",
        toStyles: { bottom: "-10%", left: "21.6998%", width: 120, rotate: -2.37 },
      },
      {
        selector: ".Bottom_right_position_new",
        toStyles: { left: "70%", bottom: "-14%", width: 120, rotate: 11.38 },
      },
    ]);
  });
}

function imageListAnimationMobile() {
  BOX_SELECTORS.forEach(removeStyle);

  const section = document.querySelector(".Page_content_overlap_media_inner");
  const triggerEl = document.querySelector(".Page_content_overlap_media_main");

  if (!section || !triggerEl) return;

  const start = "-500px top";
  const end = "100px";

  function createAnimation(settings) {
    const { selector, trigger, duration, fromStyles, finalStyles, start, end } = settings;

    gsap.set(selector, finalStyles);

    gsap.from(selector, {
      duration,
      ...fromStyles,
      scrollTrigger: {
        trigger,
        start,
        end,
        scrub: true,
        toggleActions: "play reverse play reverse",
        markers: false,
      },
    });
  }

  function animateBoxes(viewportSettings) {
    viewportSettings.forEach((setting) => {
      createAnimation({
        selector: setting.selector,
        trigger: setting.trigger || triggerEl,
        duration: setting.duration || 0.5,
        fromStyles: setting.fromStyles,
        finalStyles: setting.finalStyles,
        start: setting.start || start,
        end: setting.end || end,
      });
    });
  }

  matchMedia.add("(min-width: 0px) and (max-width: 749px)", () => {
    animateBoxes([
      {
        selector: ".Top_left_position_new",
        fromStyles: { top: "34%", left: "19.666%", width: 98.91, rotate: -17.2 },
        finalStyles: { top: "60.7239%", left: "-14.8272%", width: 98.91, rotate: -17.2 },
      },
      {
        selector: ".Top_middle_position_new",
        fromStyles: { top: "28%", left: "28%", width: 98.91, rotate: -9.15 },
        finalStyles: { top: "-10%", left: "10%", right: 0, width: 98.91, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top: "33.5%", left: "50%", width: 98.91 },
        finalStyles: { top: "-6.5%", left: "80%", width: 98.91, rotate: 158.33 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { bottom: "29.5%", left: "30.7%", width: 98.91, rotate: -2.37 },
        finalStyles: { bottom: "-15%", left: "35%", width: 98.91, rotate: -2.37 },
      },
      {
        selector: ".Bottom_right_position_new",
        fromStyles: { bottom: "33.5%", left: "54.5%", width: 98.91, rotate: 11.38 },
        finalStyles: { left: "88%", bottom: "5%", width: 98.91, rotate: 11.38 },
      },
    ]);
  });
}

function initBottomAnimation() {
  clearBottomAnimation();

  if (window.innerWidth <= 749) {
    imageListAnimationMobile();
  } else {
    imageListAnimationDesktop();
  }

  ScrollTrigger.refresh();
}

document.addEventListener("DOMContentLoaded", () => {
  initBottomAnimation();

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initBottomAnimation();
    }, 200);
  });
});
} else {
  gsap.registerPlugin(ScrollTrigger);

let matchMedia = gsap.matchMedia();

function removeStyle(tag) {
  document.querySelectorAll(tag).forEach(el => {
    el.removeAttribute("style"); // Removes all inline styles set by GSAP
  });
}

function imageListAnimation() {
  removeStyle('.Bottom_right_position_new')
  removeStyle('.Top_left_position_new')
  removeStyle('.Top_right_position_new')
  removeStyle('.Top_middle_position_new')
  removeStyle('.Bottom_left_position_new')

  let start = 'top';
  let end = '400px';

  if(window.innerWidth > 767) {
    ScrollTrigger.create({
      trigger: ".Page_content_overlap_media_inner",
      start: "top top",
      end: "bottom top",
      pin: true, 
      pinSpacing: true, 
      markers: false
    });
  } else {
    start = '-500px top';
    end = '100px';
  }
  
  function createAnimation(settings) {
    const { selector, trigger, duration, fromStyles, start, end } = settings;
    gsap.from(selector, {
      duration,
      ...fromStyles,
      scrollTrigger: {
        trigger,
        start,
        end,
        scrub: true,
        toggleActions: "play reverse play reverse",
        markers: false,
      }
    });
  }
  
  function animateBoxes(viewportSettings) {
    viewportSettings.forEach(setting => {
      createAnimation({
        selector: setting.selector,
        trigger: setting.trigger || ".Page_content_overlap_media_main",
        duration: setting.duration || 0.5,
        fromStyles: setting.fromStyles,
        start: setting.start || start,
        end: setting.end || end,
      });
    });
  }


  matchMedia.add("(min-width: 1921px)", () => {
    gsap.set(".Top_left_position_new", { top: 32, left: 0, width: 184, rotate: -17.2 });
    gsap.set(".Top_middle_position_new", { top: "-35%", right: 0, width: 184, rotate: -9.15  });
    gsap.set(".Top_right_position_new", { top: "-6.5%", left: "80%", width: 184, rotate: -15.81  });
    gsap.set(".Bottom_left_position_new", { bottom: "-25%", rotate: -2.37, left: "21.6998%", width: 184, rotate: -2.37 });
    gsap.set(".Bottom_right_position_new", { left: "70%", bottom: "-14%", width: 184, rotate: 11.38 });
  
    animateBoxes([
        {
          selector: ".Top_left_position_new",
          fromStyles: { top: "25%", left: "42.666%", width: 184, rotate: -17.2 },
        },
      {
        selector: ".Top_middle_position_new",
        fromStyles: { top: "14%", left: "44%", width: 184, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top: "24.5%", left: "52%", width: 184, rotate: 158.33 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { bottom: "17.5%", left: "46.7%", width: 184, rotate: -2.37 },
      },
            {
        selector: ".Bottom_right_position_new",
        fromStyles: { bottom: "23%", left: "51.5%", width: 184, rotate: 11.38 },
      },
    ]);
  
    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  }); 
  
  matchMedia.add("(min-width: 1440px)", () => {
    gsap.set(".Top_left_position_new", { top: 32, left: 0, width: 184, rotate: -17.2 });
    gsap.set(".Top_middle_position_new", { top: "-35%", right: 0, width: 184, rotate: -9.15  });
    gsap.set(".Top_right_position_new", { top: "-6.5%", left: "80%", width: 184, rotate: -15.81  });
    gsap.set(".Bottom_left_position_new", { bottom: "-25%", rotate: -2.37, left: "21.6998%", width: 184, rotate: -2.37 });
    gsap.set(".Bottom_right_position_new", { left: "70%", bottom: "-14%", width: 184, rotate: 11.38 });
  
    animateBoxes([
        {
          selector: ".Top_left_position_new",
          fromStyles: { top: "25%", left: "36.666%", width: 184, rotate: -17.2 },
        },
      {
        selector: ".Top_middle_position_new",
        fromStyles: { top: "14%", left: "40%", width: 184, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top: "24.5%", left: "50%", width: 184, rotate: 158.33 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { bottom: "17.5%", left: "41.7%", width: 184, rotate: -2.37 },
      },
            {
        selector: ".Bottom_right_position_new",
        fromStyles: { bottom: "23%", left: "50.5%", width: 184, rotate: 11.38 },
      },
    ]);
  
    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  });
  
  matchMedia.add("(min-width: 991px) and (max-width: 1439px)", () => {
    gsap.set(".Top_left_position_new", { top: 32, left: 0, width: 150, rotate: -17.2 });
    gsap.set(".Top_middle_position_new", { top: "-35%", right: 0, width: 150, rotate: -9.15  });
    gsap.set(".Top_right_position_new", { top: "-6.5%", left: "80%", width: 150, rotate: -15.81  });
    gsap.set(".Bottom_left_position_new", { bottom: "-25%", rotate: -2.37, left: "21.6998%", width: 150, rotate: -2.37 });
    gsap.set(".Bottom_right_position_new", { left: "70%", bottom: "-14%", width: 150, rotate: 11.38 });
  
    animateBoxes([
        {
          selector: ".Top_left_position_new",
          fromStyles: { top: "25%", left: "36.666%", width: 150, rotate: -17.2 },
        },
      {
        selector: ".Top_middle_position_new",
        fromStyles: { top: "14%", left: "40%", width: 150, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top: "24.5%", left: "50%", width: 150, rotate: 158.33 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { bottom: "17.5%", left: "41.7%", width: 150, rotate: -2.37 },
      },
            {
        selector: ".Bottom_right_position_new",
        fromStyles: { bottom: "23%", left: "50.5%", width: 150, rotate: 11.38 },
      },
    ]);
  
    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  });
  
  matchMedia.add("(min-width: 750px) and (max-width: 990px)", () => {
    gsap.set(".Top_left_position_new", { top: 32, left: 0, width: 120 });
    gsap.set(".Top_middle_position_new", { top: "-20%", right: 0, width: 120 });
    gsap.set(".Top_right_position_new", { top: "-6.5%", left: "80%", width: 120, rotate: -15.81  });
    gsap.set(".Bottom_left_position_new", { bottom: "-10%", rotate: -2.37, left: "21.6998%", width: 120 });
    gsap.set(".Bottom_right_position_new", { left: "70%", bottom: "-14%", width: 120, rotate: 11.38 });
  
    animateBoxes([
        {
          selector: ".Top_left_position_new",
          fromStyles: { top: "25%", left: "30.666%", width: 150, rotate: -17.2 },
        },
      {
        selector: ".Top_middle_position_new",
        fromStyles: { top: "18%", left: "38%", width: 150, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top: "24.5%", left: "50%", width: 150, rotate: 158.33 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { bottom: "32.5%", left: "41.7%", width: 150, rotate: -2.37 },
      },
            {
        selector: ".Bottom_right_position_new",
        fromStyles: { bottom: "32%", left: "54.5%", width: 150, rotate: 11.38 },
      },
    ]);
  
    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  });
  
  matchMedia.add("(min-width: 0px) and (max-width: 749px)", () => {
    gsap.set(".Top_left_position_new", { top: "60.7239%", left: "-14.8272%", width: 98.91, rotate: -17.2 });
    gsap.set(".Top_middle_position_new", { top: "-10%", left: "10%", right: 0, width: 98.91, rotate: -9.15 });
    gsap.set(".Top_right_position_new", { top: "-6.5%", left: "80%", width: 98.91, rotate: 158.33 });
    gsap.set(".Bottom_left_position_new", { bottom: "-15%", rotate: -2.37, left: "35%", width: 98.91 });
    gsap.set(".Bottom_right_position_new", { left: "88%", bottom: "5%", width: 98.91, rotate: 11.38 });
  
    animateBoxes([
        {
          selector: ".Top_left_position_new",
          fromStyles: { top: "34%", left: "19.666%", width: 98.91, rotate: -17.2 },
        },
      {
        selector: ".Top_middle_position_new",
        fromStyles: { top: "28%", left: "28%", width: 98.91, rotate: -9.15 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top: "33.5%", left: "50%", width: 98.91 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { bottom: "29.5%", left: "30.7%", width: 98.91, rotate: -2.37 },
      },
            {
        selector: ".Bottom_right_position_new",
        fromStyles: { bottom: "33.5%", left: "54.5%", width: 98.91, rotate: 11.38 },
      },
    ]);
  
    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  });
}

imageListAnimation()

document.addEventListener("DOMContentLoaded", () => {
  scrollTriggerRefresh()
})


function scrollTriggerRefresh(){
  const targetElement = document.querySelector(".Page_content_overlap_media");
  if (!targetElement) return;
  const observer = new IntersectionObserver((entries) => {
     
      entries.forEach(entry => {
          if (entry.isIntersecting) {
            gsap.killTweensOf("*");
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
            imageListAnimation()
          } else {
            gsap.killTweensOf("*");
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
            imageListAnimation()
          }
      });

  }, {
      root: null, 
      threshold: 0.1 
  });

  observer.observe(targetElement);
}
}